// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* INFO-PANEL */
.infoPanel {
   background: #fff;
   width: 320px;
   min-width: 320px;
   overflow-y: auto;
   transition: margin-right 0.2s;
}

.slide-right {
   margin-right: -320px;
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/viewer-controller/viewer-controller.component.css"],"names":[],"mappings":"AAAA,eAAe;AACf;GACG,gBAAgB;GAChB,YAAY;GACZ,gBAAgB;GAChB,gBAAgB;GAChB,6BAA6B;AAChC;;AAEA;GACG,oBAAoB;AACvB","sourcesContent":["/* INFO-PANEL */\n.infoPanel {\n   background: #fff;\n   width: 320px;\n   min-width: 320px;\n   overflow-y: auto;\n   transition: margin-right 0.2s;\n}\n\n.slide-right {\n   margin-right: -320px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
